import React, { useEffect, useRef, useState } from 'react'

import './index.scss'

import { createHashHistory } from 'history'

export default function CheckIfRecorded() {

  const [textValue, setTextValue] = useState('')


  const searchRef = useRef(null)

  function searchSinger(e, value) {
    if (!value) {
      e.stopPropagation();
      value = e.target.value
    }

    if (!value.trim()) {
      return window.$Msg('请先输入歌手名字')
    }
    let iconRule1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
    let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
    if (iconRule1.test(value) || iconRule2.test(value)) {
      return window.$Msg('请不要输入特殊字符')
    }
    if (value.length > 60) {
      return window.$Msg('歌手名字请控制在60字内')
    }
    var name = window.encodeURIComponent(value)
    createHashHistory().push('/get-singer-list/' + name)
  }

  useEffect(() => {
    searchRef.current.onsearch = searchSinger
  }, [])


  return (<div className="CheckIfRecorded">
    <div className="container">

      <div className="center">
        <div className="icon"></div>
        <header className="title">输入歌手名，查看是否已被酷狗音乐收录</header>
        <div className="search">
          <form action="" onSubmit={e => e.preventDefault()}>
            <input ref={searchRef} value={textValue} onChange={e => setTextValue(e.target.value)} type="search" className="search" placeholder="请输入歌手名，如：张艺兴"></input>
          </form>
          <section className="icon" onClick={() => searchSinger(null, textValue)}></section>
        </div>
        <ul>
          <li>· 被酷狗音乐收录艺人，可点击头像直接认领该艺人</li>
          <li>· 未被酷狗音乐收录的艺人，可点击“立即入驻”</li>
        </ul>
      </div>

    </div>
  </div>)
}

